export const API_ROUTES = {
    // getMRVMonitoringDetailsByVesselId
    GET_MRV_DETAILS_BY_VESSELID: (vesselMstId) => `api/MrvMonitoringPlan/${vesselMstId}`,
    GET_ALL_DROPDOWN_DATA: () => `api/MrvMonitoringPlan/alldropdowndata`,
    GET_ENABLE_DOWNLOAD_XML: (vesselMstId) => `api/MrvMonitoringPlan/mrv-thetis-enable/${vesselMstId}`,
    GET_DOWNLOAD_FILE: (vesselMstId) => `api/MrvMonitoringPlan/export-mrv-xml/${vesselMstId}`,
    GET_DOWNLOAD_PDF: (vesselMstId) => `/api/MrvMonitoringPlan/DownloadPdf/${vesselMstId}`,

    //prefill API
    GET_B3_PREFILL_TO_B5: (vesselMstId) => `api/MrvMonitoringPlan/partb/b5/getById${vesselMstId}`,
    GET_EMISSION_SOURCE_NAMES: (vesselMstId) => `api/MrvMonitoringPlan/emissionsourcenames/${vesselMstId}`,
    GET_B3_PREFILL_TO_C21: (vesselMstId) => `api/MrvMonitoringPlan/partc/GetB3DataPrefillToC21?vesselMstId=${vesselMstId}`,
    GET_MEASURING_EQUIPMENTS_NAMES: (vesselMstId) => `api/MrvMonitoringPlan/partc/GetMeasuringEquipments?vesselMstId=${vesselMstId}`,
    GET_C21_PREFILL_TO_C27: (vesselMstId) => `api/MrvMonitoringPlan/partc/GetC27DataByVesselId?vesselMstId=${vesselMstId}`,
    Validate_Plan: (planType, vesselMstId) => `api/CloneMonitoringPlan/IsCloneEnabled?planType=${planType}&vesselMstId=${vesselMstId}`,
    Get_Sections_By_PlanType: (planType) => `api/CloneMonitoringPlan/GetOptions?planType=${planType}`,
    CLONE_MRV: () => `api/CloneMonitoringPlan/CloneMonitoringPlan`,

    //A-section
    A: `api/MrvMonitoringPlan/partA`,

    //B-Section
    B1: (vesselMstId) => `api/MrvMonitoringPlan/partb/b1/${vesselMstId}`,
    B2: (vesselMstId) => `api/MrvMonitoringPlan/partb/b2/${vesselMstId}`,
    B3: (vesselMstId) => `api/MrvMonitoringPlan/partb/b3/${vesselMstId}`,
    B4: (vesselMstId) => `api/MrvMonitoringPlan/partb/b4/${vesselMstId}`,
    B5: (vesselMstId) => `api/MrvMonitoringPlan/partb/b5/${vesselMstId}`,
    B6: (vesselMstId) => `api/MrvMonitoringPlan/partb/b6/${vesselMstId}`,
    B7: (vesselMstId) => `api/MrvMonitoringPlan/partb/b7/${vesselMstId}`,
    B8: (vesselMstId) => `api/MrvMonitoringPlan/partb/b8/${vesselMstId}`,
    B9: (vesselMstId) => `api/MrvMonitoringPlan/partb/b9/${vesselMstId}`,

    //C-Section
    C1: (vesselMstId) => `api/MrvMonitoringPlan/partc/c1/${vesselMstId}`,
    C21: (vesselMstId) => `api/MrvMonitoringPlan/partc/c21/${vesselMstId}`,
    C22: (vesselMstId) => `api/MrvMonitoringPlan/partc/c22/${vesselMstId}`,
    C23: (vesselMstId) => `api/MrvMonitoringPlan/partc/c23/${vesselMstId}`,
    C24: (vesselMstId) => `api/MrvMonitoringPlan/partc/c24/${vesselMstId}`,
    C25: (vesselMstId) => `api/MrvMonitoringPlan/partc/c25/${vesselMstId}`,
    C26: (vesselMstId) => `api/MrvMonitoringPlan/partc/c26/${vesselMstId}`,
    C27: (vesselMstId) => `api/MrvMonitoringPlan/partc/c27/${vesselMstId}`,
    C28: (vesselMstId) => `api/MrvMonitoringPlan/partc/c28/${vesselMstId}`,
    C29: (vesselMstId) => `api/MrvMonitoringPlan/partc/c29/${vesselMstId}`,
    C210: (vesselMstId) => `api/MrvMonitoringPlan/partc/c210/${vesselMstId}`,
    C211: (vesselMstId) => `api/MrvMonitoringPlan/partc/c211/${vesselMstId}`,
    C212: (vesselMstId) => `api/MrvMonitoringPlan/partc/c212/${vesselMstId}`,
    C213: (vesselMstId) => `api/MrvMonitoringPlan/partc/c213/${vesselMstId}`,
    C3: (vesselMstId) => `api/MrvMonitoringPlan/partc/c3/${vesselMstId}`,
    C41: (vesselMstId) => `api/MrvMonitoringPlan/partc/c41/${vesselMstId}`,
    C42: (vesselMstId) => `api/MrvMonitoringPlan/partc/c42/${vesselMstId}`,
    C51: (vesselMstId) => `api/MrvMonitoringPlan/partc/c51/${vesselMstId}`,
    C52: (vesselMstId) => `api/MrvMonitoringPlan/partc/c52/${vesselMstId}`,
    C61: (vesselMstId) => `api/MrvMonitoringPlan/partc/c61/${vesselMstId}`,
    C62: (vesselMstId) => `api/MrvMonitoringPlan/partc/c62/${vesselMstId}`,

    //D-Section
    D1: (vesselMstId) => `/api/MrvMonitoringPlan/partd/d1/${vesselMstId}`,
    D2: (vesselMstId) => `/api/MrvMonitoringPlan/partd/d2/${vesselMstId}`,
    D3: (vesselMstId) => `/api/MrvMonitoringPlan/partd/d3/${vesselMstId}`,
    D4: (vesselMstId) => `/api/MrvMonitoringPlan/partd/d4/${vesselMstId}`,

    //E-Section
    E1: (vesselMstId) => `/api/MrvMonitoringPlan/parte/e1/${vesselMstId}`,
    E2: (vesselMstId) => `/api/MrvMonitoringPlan/parte/e2/${vesselMstId}`,
    E3: (vesselMstId) => `/api/MrvMonitoringPlan/parte/e3/${vesselMstId}`,
    E4: (vesselMstId) => `/api/MrvMonitoringPlan/parte/e4/${vesselMstId}`,
    E5: (vesselMstId) => `/api/MrvMonitoringPlan/parte/e5/${vesselMstId}`,
    E6: (vesselMstId) => `/api/MrvMonitoringPlan/parte/e6/${vesselMstId}`,
    E7: (vesselMstId) => `/api/MrvMonitoringPlan/parte/e7/${vesselMstId}`,
    E8: (vesselMstId) => `/api/MrvMonitoringPlan/parte/e8/${vesselMstId}`,

    //F-Section
    F1: (vesselMstId) => `/api/MrvMonitoringPlan/partf/f1/${vesselMstId}`,
    F2: (vesselMstId) => `/api/MrvMonitoringPlan/partf/f2/${vesselMstId}`,

}